export const REDUCER_NAME = 'adverityAuthorizations';

export const AUTHORIZATIONS_ROUTES = {
    NEW: '/adverity-authorizations/add'
};

export const AUTHORIZATIONS_LIST_PAGE_SIZE = 50;
